export default __webpack_public_path__ + "static/media/surrounding_area_icon.d494dd15.svg";